import React from 'react'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import { IconButton } from '../../IconButton'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexWrap: 'inherit'
  }
})

interface DialogActionArrowProps {
  hidden: boolean
  onPrevious?: () => void
  onNext?: () => void
}

function DialogActionArrows({ hidden, onPrevious, onNext }: DialogActionArrowProps) {
  const classes = useStyles()
  return (
    !hidden && (
      <div className={classes.root}>
        <IconButton disabled={!onPrevious} onClick={onPrevious}>
          <NavigateBeforeIcon />
        </IconButton>
        <IconButton disabled={!onNext} onClick={onNext}>
          <NavigateNextIcon />
        </IconButton>
      </div>
    )
  )
}

export default DialogActionArrows
